// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"solar-tracker_productcontent__SvjGP"};